import { inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";

import { BudgetService } from "../../../modules/budgets/services/budget-service/budget-service.service";

export const budgetGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const budget = inject(BudgetService);
  const router = inject(Router);
  const id = route.paramMap.get("id");

  return !!budget.getCurrentBudgetValue() || router.navigate(["/orcamentos", id]);
};
